import _axios from '@/util/httpConfig.js'
// 获取视频点播
export const getPlayer = (page) => {
  const data = {"appCode":"APPAFBB8CD316AFF62","contentStatus":"","contentTitle":"","moduleCode":"RESCF7BE51866B3E3E","moduleNavCode":"","pageNo":page,"pageSize":6,"status":"","tenantCode":"96F307B9D0EDF9F","typeCode":""}
  return _axios('POST', '/common-content/contentNews/list','' ,data)
}
// 获取视频详情
export const getPlayerDetail = (contentCode, tenantCode) => {
  return _axios('GET', `common-content/contentNews/get?contentCode=${contentCode}&tenantCode=${tenantCode}`)
}


// WEBPACK FOOTER //
// ./src/api/player.js